import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import Slider from "react-slick";
import AthProduct from "../../components/recommendations/AthProduct";
import AthReviewModal from "../../components/recommendations/AthReviewModal";
import Modal from "react-responsive-modal";
import { infoPopup } from "../../data/infopopup";
import * as util from "../../../utils/util";
import * as aaUtil from "../../utils/aaUtils";

import "./AthRecommendations.css";

const sliderSettings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  className: "hair-slider-recommendations",
  responsive: [
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        className: "hair-slider-recommendations"
      }
    },
    {
      breakpoint: 552,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        className: "hair-slider-recommendations"
      }
    }
  ]
};

const categoryMap = ["wash", "condition", "dry", "style", "refresh"];

const InformationButton = styled.div`
  font-size: 21px;
  color: #ffad94;
  margin-left: 20px;
  cursor: default;
  font-family: "Open Sans", Helevetica, Arial, sans-serif
  line-height: 15px;
  cursor: pointer;

  .info-popup {
      max-width: 414px;
      padding: 2.5% 3%;
      left: 0;
      z-index: 2;
      white-space: pre-line;
      visibility: hidden;
      background: #fff;
      position: absolute;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

      p {
          font-size: 13px;
          color: #323232;

      }

      span {
          font-family: Montserrat, Helevetica, Arial, sans-serif;
          font-size: 14px;
          color: #262e66;
          font-weight: 600;
      }
  }

  &:hover .info-popup {
      visibility: visible;
  }
`;

class AthRecommendations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recommendedProducts: [],
      extraRecommendations: [],
      openAdditionalCategories: false,
      showReviewModal: false,
      currentCategory: ""
    };
  }

  componentWillMount() {
    const userId = localStorage.getItem("ath_user_id");
    if (!userId) {
      this.props.history.push("/ath/login");
    } else {
      this.fetchResult();

      this.toggleBundle(true);
    }
  }

  componentDidMount() {
    const userId = localStorage.getItem("ath_user_id");
    if (userId) {
      this.checkReviewStatus();
    }

    window.zE("webWidget", "show");
    document.addEventListener("Shoppableloaded", function() {
      //ADD TO CART

      window.Product.eventSubscriber("ADD_TO_CART", obj => {
        let object = JSON.parse(obj);
        let product = object.event.lastQtyAdded;
        let id = product.upc;
        let name = product.name;
        let price = product.price;
        let brand = product.name;
        let qty = product.qty;
        aaUtil.scAdd_add_to_cart(id, name, price, brand, qty, "Haircare");
      });

      //OPEN CART
      window.Product.eventSubscriber("OPEN_CART", () => {
        aaUtil.event44_click_cart_icon();
      });

      //VIEW CART ON ALL THINGS HAIR
      window.Product.eventSubscriber("EVENT_MINI_CART_VIEW_CART", e => {
        aaUtil.scView_view_external_cart();
      });
    });
  }

  componentWillUnmount() {
    document.removeEventListener("Shoppableloaded", function() {
    });

    window.zE("webWidget", "hide");
  }

  checkReviewStatus = () => {
    const userId = localStorage.getItem("ath_user_id");
    fetch("/api/ath-feedbacks/exist?user-id=" + userId, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-auth-token": localStorage.getItem("ath_auth_token")
      }
    })
      .then(response => {
        if (response.status >= 400 && response.status < 500) {
          setTimeout(this.openReviewModal, 30000);
        } else {
          return;
        }
      })
      .catch(function(err) {
        console.log("There was a problem checking review status.");
      });
  };

  sendReview = (rating, comment) => {
    const userId = localStorage.getItem("ath_user_id");
    fetch("/api/ath-feedbacks", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-auth-token": localStorage.getItem("ath_auth_token")
      },
      body: JSON.stringify({
        athUserId: userId,
        rating: rating,
        comment: comment
      })
    })
      .then(response => {
        if (response.status >= 400) {
          throw new Error("Error submitting.");
        } else {
          return;
        }
      })
      .catch(function(err) {
        alert("There was submitting your review.");
      });
  };

  toggleBundle = mount => {
    const script = document.createElement("script");

    if (mount) {
      script.setAttribute(
        "options",
        `"cart_tab_parent_id": "header-area", "token":"${process.env.REACT_APP_UL_SHOPPABLE_TOKEN}","developerMode":"${process.env.REACT_APP_UL_SHOPPABLE_DEVELOPER_MODE}", "productGroup":"none", "order_complete_page":"/thank-you/","page_after_complete_page":"/thank-you/","your_cart_message":"In your bag","view_bag_message":"View Cart","view_cart_page":"${process.env.REACT_APP_UL_ATH_CART_PAGE}","out_of_stock_message":"This product is available at the retailer shown below. You may purchase it by clicking on the button.","out_of_stock_button_text":"Buy Direct From Amazon.com","off_site_checkout":"true","off_site_new_window":"true"`
        );

      script.setAttribute("id", "shoppable_bundle");

      script.src = process.env.REACT_APP_UL_SHOPPABLE_BUNDLE;
      script.async = true;
      document.body.appendChild(script);
    }
  };

  fetchResult = () => {
    const userId = localStorage.getItem("ath_user_id");
    fetch("/api/ath/recommendations?user-id=" + userId, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-auth-token": localStorage.getItem("ath_auth_token")
      }
    })
      .then(response => response.json())
      .then(responseJson => {
        // console.log(responseJson);
        this.setState({
          recommendedProducts: responseJson.recs,
          extraRecommendations: responseJson.extraRecs
        });
        // responseJson.forEach(item => {
        //   this.setState({
        //   [util.camelize(item.type)]: item,
        //   selectedHairGoals: responseJson.find(cat => cat.type === "Concern").selections.split(",").map(ind => parseInt(ind))
        //   });
        // });
        // this.setState({ loadingDone: true });
      })
      .catch(function(err) {
        alert(
          "There was a problem getting your recommendations. Please try again."
        );
      });
  };

  handleProductClick = (upc, name, price, brand, quantity, category) => {
    aaUtil.event38_click_to_purchase(
      upc,
      name,
      price,
      brand,
      quantity,
      category
    );
    // this.setState({ currentCategory: category });
    // Acknowledgements
    window.Product.pop_pdp("upc", upc, "addProduct");
  };

  renderRecommendations = () => {
    let categoriesArr = this.state.recommendedProducts
      .map(product => product.routine)
      .filter((category, ind, arr) => arr.indexOf(category) === ind)
      .sort((a, b) => categoryMap.indexOf(a) - categoryMap.indexOf(b));

    return categoriesArr.map((category, ind) => {
      let categoryProducts = this.state.recommendedProducts
        .filter(product => {
          return product.smartId && product.routine === category;
        })
        .map(product => {
          return (
            <AthProduct
              product={product}
              handleProductClick={this.handleProductClick}
            />
          );
        });
      return (
        <div className="ath-recommendations__category-row">
          <div className="ath-recommendations__category-header">
            <h3 className="ath-recommendations__category-header-text">
              Step {ind + 1} -{" "}
              {category.includes("dry")
                ? "Dry and Protect"
                : util.capitalize(category)}
            </h3>
            <InformationButton>
              &#9432;
              <div className="info-popup ath-info-popup">
                <div className="info-popup__body">
                  <div className="info-popup__group">
                    <div className="info-poup__group-header-container">
                      <h4 className="info-popup__group-header">
                        {category.includes("dry")
                          ? "Dry and Protect"
                          : util.capitalize(category)}
                      </h4>
                    </div>
                    <div className="info-popup__group-body">
                      <div className="info-popup__group-body-section">
                        <h5 className="info-popup__group-body-section-header">
                          Why do you need this?
                        </h5>
                        <p className="info-poup__group-body-section-content">
                          {infoPopup[category].need}
                        </p>
                      </div>
                      <div className="info-popup__group-body-section">
                        <h5 className="info-popup__group-body-section-header">
                          How to use it?
                        </h5>
                        <p className="info-poup__group-body-section-content">
                          {infoPopup[category].use}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </InformationButton>
          </div>
          <div className="ath-recommendations__category-products products">
            <Slider {...sliderSettings}>{categoryProducts}</Slider>
          </div>
        </div>
      );
    });
  };

  renderExtra = () => {
    let categoriesArr = this.state.extraRecommendations
      .map(product => product.routine)
      .filter((category, ind, arr) => arr.indexOf(category) === ind)
      .sort((a, b) => categoryMap.indexOf(a) - categoryMap.indexOf(b));

    return categoriesArr.map((category, ind) => {
      let categoryProducts = this.state.extraRecommendations
        .filter(product => product.routine === category)
        .map(product => {
          return (
            <AthProduct
              product={product}
              handleProductClick={this.handleProductClick}
            />
          );
        });
      return (
        <div className="ath-recommendations__category-row">
          <div className="ath-recommendations__category-header">
            <h3 className="ath-recommendations__category-header-text">
              {category.includes("dry")
                ? "Dry and Protect"
                : util.capitalize(category)}
            </h3>
            <InformationButton>
              &#9432;
              <div className="info-popup ath-info-popup">
                <div className="info-popup__body">
                  <div className="info-popup__group">
                    <div className="info-poup__group-header-container">
                      <h4 className="info-popup__group-header">
                        {category.includes("dry")
                          ? "Dry and Protect"
                          : util.capitalize(category)}
                      </h4>
                    </div>
                    <div className="info-popup__group-body">
                      <div className="info-popup__group-body-section">
                        <h5 className="info-popup__group-body-section-header">
                          Why do you need this?
                        </h5>
                        <p claassName="info-poup__group-body-section-content">
                          {infoPopup[category].need}
                        </p>
                      </div>
                      <div className="info-popup__group-body-section">
                        <h5 className="info-popup__group-body-section-header">
                          How to use it?
                        </h5>
                        <p claassName="info-poup__group-body-section-content">
                          {infoPopup[category].use}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </InformationButton>
          </div>
          <div
            className={
              this.state.openAdditionalCategories
                ? "ath-recommendations__category-products products show"
                : "ath-recommendations__category-products products"
            }
          >
            <Slider {...sliderSettings}>{categoryProducts}</Slider>
          </div>
        </div>
      );
    });
  };

  handleOpenAdditionalCategories = () => {
    this.setState({
      openAdditionalCategories: !this.state.openAdditionalCategories
    });
  };

  openReviewModal = () => {
    this.setState({ showReviewModal: true });
  };

  onCloseReviewModal = () => {
    this.setState({ showReviewModal: false });
  };

  render() {
    return (
      <div id="ath-recommendations" className="ath-recommendations">
        {this.renderRecommendations()}
        {this.state.extraRecommendations &&
        this.state.extraRecommendations.length > 0 ? (
          <div className="ath-recommendations__extra-recommendations view-more-section">
            <div
              className="view-more-title"
              onClick={this.handleOpenAdditionalCategories}
            >
              <div
                className={
                  this.state.openAdditionalCategories
                    ? "triangle rotate"
                    : "triangle"
                }
              />
              What else is good for me?
            </div>
            <div
              className={
                this.state.openAdditionalCategories
                  ? "products show"
                  : "products"
              }
            >
              {this.renderExtra()}
            </div>
          </div>
        ) : null}
        <Modal
          open={this.state.showReviewModal}
          little
          onClose={this.onCloseReviewModal}
          closeOnOverlayClick={false}
          classNames={{
            overlay: "ha-overlay ath-review-modal__overlay",
            modal: "ha-modal ath-review-modal__container"
          }}
        >
          <div className="ath-info-review-modal__body">
            <AthReviewModal
              onCloseReviewModal={this.onCloseReviewModal}
              sendReview={this.sendReview}
            />
          </div>
        </Modal>
      </div>
    );
  }
}

export default withRouter(AthRecommendations);



// WEBPACK FOOTER //
// ./src/ath/views/recommendations/AthRecommendations.js